import styled from "styled-components";

const SpeechBubble = (props: { title: string }) => {
  return (
    <Style>
      <div className="speech-bubble">
        <div className="content">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_discount.svg`}
            alt="discount"
          />
          <p>{props.title}</p>
        </div>
      </div>
    </Style>
  );
};

export default SpeechBubble;

const Style = styled.div`
  .speech-bubble {
    position: relative;
    padding: 2px;
    border-radius: 10px;
    background: linear-gradient(90deg, #4dd2ae -2.34%, #90c2e6 97.14%);
  }
  .content {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 10px;
    background: #000;
    padding: 11px 24px;
  }
  .speech-bubble::before {
    content: "";
    position: absolute;
    bottom: -9.9px;
    right: 38px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #90c2e6;
  }

  .speech-bubble::after {
    content: "";
    position: absolute;
    bottom: -5.9px;
    right: 42px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #000;
  }
  p {
    font-size: 20px;
    line-height: 24px;
    color: #fff;
    font-weight: 600;
  }
`;
